import React from "react"
import PropTypes from "prop-types"

const ESTADOS = {
  excelente: { label: "Excelente", color: "#10b981", bg: "#d1fae5" },
  bueno: { label: "Bueno", color: "#3b82f6", bg: "#dbeafe" },
  atencion: { label: "Atención", color: "#f59e0b", bg: "#fef3c7" },
  regular: { label: "Regular", color: "#f59e0b", bg: "#fef3c7" },
  critico: { label: "Crítico", color: "#ef4444", bg: "#fee2e2" },
  desconocido: { label: "—", color: "#64748b", bg: "#f1f5f9" },
}

const formatNumber = n => (typeof n === "number" ? n.toLocaleString("es-CO") : n ?? "—")

const formatDensity = d => {
  if (d === null || d === undefined) return "—"
  const num = typeof d === "string" ? parseFloat(d) : d
  return isNaN(num) ? "—" : `${num.toFixed(2)}%`
}

const Card = ({ icon, label, value, accent = "#3b82f6", sub }) => (
  <div
    style={{
      flex: "1 1 180px",
      background: "#fff",
      border: "1px solid #e2e8f0",
      borderRadius: 14,
      padding: "18px 20px",
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0,
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: `${accent}1a`,
          color: accent,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 18,
          flexShrink: 0,
        }}
      >
        <i className={`mdi ${icon}`} />
      </div>
      <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.4 }}>
        {label}
      </span>
    </div>
    <div style={{ fontSize: 24, fontWeight: 700, color: "#0f172a", lineHeight: 1.1 }}>{value}</div>
    {sub && <div style={{ fontSize: 12, color: "#94a3b8" }}>{sub}</div>}
  </div>
)

Card.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  accent: PropTypes.string,
  sub: PropTypes.node,
}

const ResumenCards = ({ resumen }) => {
  if (!resumen) return null

  const totales = resumen.totales || {}
  const estado = ESTADOS[totales.estado_general] || ESTADOS.desconocido

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
      <Card
        icon="mdi-tag-multiple-outline"
        label="Prefijos"
        value={formatNumber(totales.total_prefijos)}
        accent="#6366f1"
      />
      <Card
        icon="mdi-source-branch"
        label="Sucursales"
        value={formatNumber(totales.total_sucursales)}
        accent="#0ea5e9"
      />
      <Card
        icon="mdi-file-document-multiple-outline"
        label="Folios emitidos"
        value={formatNumber(totales.total_folios_emitidos)}
        accent="#8b5cf6"
        sub={`de ${formatNumber(totales.total_rango_esperado)} esperados`}
      />
      <Card
        icon="mdi-alert-circle-outline"
        label="Gaps reales"
        value={formatNumber(totales.total_gaps_reales)}
        accent={totales.total_gaps_reales > 0 ? "#f59e0b" : "#10b981"}
        sub="folios faltantes"
      />
      <Card
        icon="mdi-gauge"
        label="Densidad"
        value={formatDensity(totales.densidad_general)}
        accent="#3b82f6"
      />
      <Card
        icon="mdi-shield-check-outline"
        label="Estado"
        value={
          <span
            style={{
              display: "inline-block",
              padding: "4px 12px",
              borderRadius: 999,
              background: estado.bg,
              color: estado.color,
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {estado.label}
          </span>
        }
        accent={estado.color}
        sub={resumen.tiempo_procesamiento ? `Procesado en ${resumen.tiempo_procesamiento}` : null}
      />
    </div>
  )
}

ResumenCards.propTypes = {
  resumen: PropTypes.shape({
    totales: PropTypes.shape({
      total_prefijos: PropTypes.number,
      total_sucursales: PropTypes.number,
      total_folios_emitidos: PropTypes.number,
      total_rango_esperado: PropTypes.number,
      total_gaps_reales: PropTypes.number,
      densidad_general: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      estado_general: PropTypes.string,
    }),
    tiempo_procesamiento: PropTypes.string,
  }),
}

export default ResumenCards
